import { Translatable } from "@icc/shared/helpers";

export type SecurityBoltType = 'automatic' | 'manual' | 'espagnolette';

export class RollerSecurityBolt {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Typ rygla (automatyczny, ręczny lub zamek baskwilowy) */
    boltType: SecurityBoltType;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}

export interface IccRollerSecurityBolt {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    boltType: SecurityBoltType;
    /** Powiązane typy produktów */
    shutterTypesIds: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
